import { useTranslation } from 'react-i18next';

import './style.scss';
import { ButtonCTA } from '@src/global/components/UI Elements/ButtonCTA';
import { ReactComponent as UserTealIcon } from '@assets/images/UserTeal.svg';

import {
  CART_CHECKOUT_BASE_URL,
  Pages,
  CUSTOMER_PORTAL_URL,
} from '@global/App/constants/constants';
import { SiteConfig } from '@src/global/utils/SiteConfig';

interface AccountInfoProps {
  isSubscription: boolean;
  isGuestOrder?: boolean;
  isBulkOrder?: boolean;
}

const hybrisAccountUrl =
  'https://customer.wiley.com/CGI-BIN/lansaweb?procfun+shopcart+shcfn11+funcparms+parmurl(l0350):https%3A%2F%2Fwww.wiley.com+source(A0100):HYBRIS_US';

export const AccountInfo = ({
  isSubscription,
  isGuestOrder = false,
  isBulkOrder = false,
}: AccountInfoProps) => {
  const { t } = useTranslation();
  const { isB2CSite } = SiteConfig.getConfig();

  const handleOpenMyAccount = () => {
    let url = hybrisAccountUrl;

    if (isSubscription) {
      url = isB2CSite
        ? CUSTOMER_PORTAL_URL
        : SiteConfig.buildRedirectUrl(
            CART_CHECKOUT_BASE_URL,
            Pages.SUBSCRIPTION_DETAILS
          );
    }

    window.open(url, '_blank');
  };

  const getTitleKey = (): string => {
    let titleKey = 'title';
    if (isBulkOrder) {
      titleKey = 'bulkOrderTitle';
    } else if (isGuestOrder) {
      titleKey = 'guestTitle';
    }
    return `confirmation.accountInfo.${titleKey}`;
  };
  const btnTitle = t('confirmation.accountInfo.myAccount');

  return (
    <div className="order-confirmation__account">
      <span className="order-confirmation__account-title">
        {t(getTitleKey())}
      </span>

      <ButtonCTA
        onClick={handleOpenMyAccount}
        variant="primary"
        hidden={isGuestOrder}
        className="order-confirmation__account-link"
      >
        <span className="order-confirmation__account-link__title">
          {btnTitle}
        </span>

        <UserTealIcon />
      </ButtonCTA>
    </div>
  );
};
